/**
 * OIDC-type fields: acquisition-mode select plus the brokered/direct field
 * sets it switches between.
 */

import type { ReactElement } from 'react';
import type { ProviderFormData, SetProviderField } from './providerFormTypes';
import { BrokeredProviderFields } from './BrokeredProviderFields';
import { DirectProviderFields } from './DirectProviderFields';

interface OidcProviderFieldsProps {
  form: ProviderFormData;
  setField: SetProviderField;
  hasClientSecret: boolean;
  extraAuthParamsJson: string;
  onExtraAuthParamsChange: (value: string) => void;
}

export function OidcProviderFields({
  form,
  setField,
  hasClientSecret,
  extraAuthParamsJson,
  onExtraAuthParamsChange,
}: OidcProviderFieldsProps): ReactElement {
  return (
    <>
      <label className="dialog__field">
        Acquisition Mode
        <select
          value={form.acquisition_mode ?? 'direct'}
          onChange={(e) =>
            { setField('acquisition_mode', e.target.value as 'brokered' | 'direct'); }
          }
        >
          <option value="direct">Direct</option>
          <option value="brokered">Brokered</option>
        </select>
      </label>
      {form.acquisition_mode === 'brokered' ? (
        <BrokeredProviderFields
          form={form}
          setField={setField}
          hasClientSecret={hasClientSecret}
        />
      ) : (
        <DirectProviderFields
          form={form}
          setField={setField}
          hasClientSecret={hasClientSecret}
          extraAuthParamsJson={extraAuthParamsJson}
          onExtraAuthParamsChange={onExtraAuthParamsChange}
        />
      )}
    </>
  );
}
